export default __webpack_public_path__ + "static/media/energy.b2b366de.svg";